var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00488 15.8496H19.4111C19.666 15.8496 19.9033 15.6299 19.9033 15.3398C19.9033 15.0498 19.666 14.8301 19.4111 14.8301H9.1543C8.60059 14.8301 8.25781 14.4785 8.16992 13.8809L8.00293 12.7383H19.3408C20.5273 12.7383 21.0986 12.0352 21.2744 10.8838L21.9951 6.10254C22.0127 6.00586 22.0303 5.85645 22.0303 5.79492C22.0303 5.41699 21.7666 5.1709 21.3447 5.1709H6.86914L6.66699 3.78223C6.58789 3.26367 6.40332 3 5.7002 3H2.50098C2.22852 3 2 3.22852 2 3.50977C2 3.78223 2.22852 4.01953 2.50098 4.01953H5.63867L7.11523 14.0391C7.27344 15.1553 7.8623 15.8496 9.00488 15.8496ZM20.8965 6.19043L20.2109 10.7695C20.1143 11.3672 19.8242 11.7188 19.2705 11.7188H7.84473L7.02734 6.19043H20.8965ZM9.91016 20.0771C10.6748 20.0771 11.2812 19.4707 11.2812 18.7061C11.2812 17.9414 10.6748 17.335 9.91016 17.335C9.14551 17.335 8.53906 17.9414 8.53906 18.7061C8.53906 19.4707 9.14551 20.0771 9.91016 20.0771ZM17.9873 20.0771C18.752 20.0771 19.3584 19.4707 19.3584 18.7061C19.3584 17.9414 18.752 17.335 17.9873 17.335C17.2227 17.335 16.6074 17.9414 16.6074 18.7061C16.6074 19.4707 17.2227 20.0771 17.9873 20.0771Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.40f7f25b231ef3a92c944aa3d822722f.svg";
export { ForwardRef as ReactComponent };